import styled from 'styled-components';

export const Container = styled.div`background: #FFFFFF;`;
export const Padding64 = styled.div`padding: 4rem;`;

export const KeyPadContainer = styled.div`display: flex; justify-content: center;`;
export const KeyPadWrapper = styled.div`width: 51.5rem; display: flex; flex-direction: column;`;
export const FlexRowGap = styled.div`display: flex; flex-direction: row; align-items: ${({ align }) => (align === undefined ? 'center' : align)}; gap: ${({ gap }) => gap}px;`;
export const FlexRowSpace = styled.div`display: flex; flex-direction: row; align-items: ${({ align }) => (align === undefined ? 'center' : align)}; ${({ gap }) => gap !== undefined && `gap: ${gap}px;`} justify-content: space-between;`;
export const FlexRowEnd = styled.div`display: flex; flex-direction: row; justify-content: end;`;
export const FlexRowCenter = styled.div`display: flex; flex-direction: row; align-items: center; justify-content: center;`;
export const FlexColumnGap = styled.div`display: flex; flex-direction: column; gap: ${({ gap }) => gap}px;`;
export const FlexColumnSpace = styled.div`display: flex; flex-direction: column; align-items: center; justify-content: space-between;`;
export const FlexRowStart = styled.div`display: flex; flex-direction: row; align-items: start; justify-content: space-between;`;
export const ModalButtonSection = styled.div`
    padding: 54px;
    box-sizing: border-box;
    height: 156px;
    display: flex;
    flex-direction: row;
    justify-content: end;
`;
export const ModalButtonContainer = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #FFFFFF;
    border: 2.5px solid #000000;
    width: 48px;
    height: 48px;
`;
